import { render, staticRenderFns } from "./FiltersContainer.vue?vue&type=template&id=55f853d1&scoped=true&"
import script from "./FiltersContainer.vue?vue&type=script&lang=js&"
export * from "./FiltersContainer.vue?vue&type=script&lang=js&"
import style0 from "./FiltersContainer.vue?vue&type=style&index=0&id=55f853d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f853d1",
  null
  
)

export default component.exports